module.exports = __webpack_public_path__ + "static/media/Stat_wine_left.b4649911.svg";